import axios, { AxiosInstance } from 'axios';

const cmsAPI: AxiosInstance = axios.create({
    baseURL: KNOX_SITE_ROOT,
    withCredentials: true
});

export default cmsAPI;